var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "companies-select" },
    [
      _c(
        "v-select",
        {
          attrs: {
            id: "type",
            label: "text",
            autocomplete: "",
            options: _vm.companies,
            clearable: false,
            multiple: "",
            disabled: _vm.loading,
          },
          on: { input: _vm.setCompanies },
          model: {
            value: _vm.companiesSelected,
            callback: function ($$v) {
              _vm.companiesSelected = $$v
            },
            expression: "companiesSelected",
          },
        },
        [
          _c("span", { attrs: { slot: "no-options" }, slot: "no-options" }, [
            _vm._v("Nada que mostrar."),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }